import { render, staticRenderFns } from "./InfiniteContent.vue?vue&type=template&id=03479308&lang=pug&"
import script from "./InfiniteContent.vue?vue&type=script&lang=js&"
export * from "./InfiniteContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports